import BankTransferImage from '@assets/methods/bank-transfer.svg'
import BankwireImage from '@assets/methods/bankwire.svg'
import BatchPaymentImage from '@assets/methods/batch-payment.svg'
import CryptoImage from '@assets/methods/crypto.svg'
import CardImage from '@assets/methods/debit-card.svg'
import InternalTransferImage from '@assets/methods/internal-transfer.svg'
import JetonImage from '@assets/methods/jeton.svg'
import KingdomCashImage from '@assets/methods/kingdom-cash.svg'
import SwiftImage from '@assets/methods/swift.svg'
import { configuration, PaymentMethods, WithdrawalSubFlows } from 'mmfintech-backend-api'
import { getPaymentMethodImageUrl } from 'mmfintech-commons'

type PaymentOptionIconProps = {
  paymentOption: string
}

function PaymentOptionIcon({ paymentOption }: PaymentOptionIconProps) {
  if (paymentOption) {
    switch (paymentOption) {
      case PaymentMethods.INSTANT_BANK_TRANSFER:
        return <img src={BankTransferImage} alt='' />
      case PaymentMethods.JETON_CASH:
        return <img src={JetonImage} alt='' />
      case PaymentMethods.BANKWIRE:
        return <img src={BankwireImage} alt='' />
      case PaymentMethods.SWIFT_BANKWIRE:
        return <img src={SwiftImage} alt='' />
      case PaymentMethods.CREDIT_CARD:
      case WithdrawalSubFlows.PAY_TO_CARD:
        return <img src={CardImage} alt='' />
      case PaymentMethods.KINGDOM_CASH:
      case WithdrawalSubFlows.INTERNAL_TRANSFER:
        return <img src={KingdomCashImage} alt='' />
      case PaymentMethods.CRYPTO:
        return <img src={CryptoImage} alt='' />
      case 'SUB_ACCOUNTS':
      case WithdrawalSubFlows.MASTERCARD:
        return <img src={BankTransferImage} alt='' />
      case WithdrawalSubFlows.INTRA_ACCOUNT_TRANSFER:
        return <img src={InternalTransferImage} alt='' />
      case WithdrawalSubFlows.BATCH:
        return <img src={BatchPaymentImage} alt='' />

      default:
        return <img src={`${configuration.getBaseUrl()}${getPaymentMethodImageUrl(paymentOption)}`} alt='' />
    }
  }
  return null
}

export default PaymentOptionIcon
